module.exports = function () {
    return new Date().toISOString()
}